import {announce} from '@github-ui/aria-live'
import {copyText} from '@github-ui/copy-to-clipboard'
import {CopyIcon, LinkExternalIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'

const LINK_COPIED = 'Link copied.'
const COPY_FAILED = 'Could not copy link.'

/** "Open in new tab" and "Copy link" for one card's menu. */
export function BoardCardActions({permalink}: {permalink: string}) {
  return (
    <>
      <ActionList.LinkItem href={permalink} target="_blank" rel="noopener noreferrer">
        <ActionList.LeadingVisual>
          <LinkExternalIcon />
        </ActionList.LeadingVisual>
        Open in new tab
      </ActionList.LinkItem>
      <ActionList.Item onSelect={() => void copyLink(permalink)}>
        <ActionList.LeadingVisual>
          <CopyIcon />
        </ActionList.LeadingVisual>
        Copy link
      </ActionList.Item>
    </>
  )
}

async function copyLink(permalink: string) {
  try {
    // Account issues have a path for a permalink, which is no use pasted anywhere else.
    await copyText(new URL(permalink, window.location.origin).href)
    announce(LINK_COPIED)
  } catch {
    announce(COPY_FAILED)
  }
}
